import axios from 'axios';
import { trim } from 'ramda';

import * as urls from 'constants/urls';
import { getFcmToken } from 'utils/firebase';
import { toBase64 } from 'helpers/base64Helper';

export const changeUserPasswordHandler = ({ payload }) => axios.post(urls.CHANGE_USER_PASSWORD.stringify(), payload);

export const getPasswordCheckHandler = ({ payload }) => axios.get(
    urls.PASSWORD_CHECK.stringify(),
    { params: { authKey: payload } }
);

export const getUserHandler = () => axios.get(urls.USER.stringify());
export const getCompanyInfoHandler = () => axios.get(urls.COMPANY_INFO.stringify());

const unicodeToLatin = latinString => unescape(encodeURIComponent(latinString));

export const loginHandler = ({ payload }) => {
    if (!payload.sso) {
        const { code, email, password: unicodePassword } = payload;
        const username = trim(email);
        const password = unicodeToLatin(trim(unicodePassword));
        return axios.post(urls.LOGIN.stringify({ type: 'common' }), { code }, {
            headers: { 'X-Authorization': `Basic ${toBase64(`${username}:${password}`)}` },
        });
    } else {
        return axios.get(urls.LOGIN.stringify({ type: 'sso' }));
    }
};

export const passwordConfirmHandler = ({ payload }) => {
    const password = unicodeToLatin(payload.password);
    return axios.post(urls.RESET.stringify(), {...payload, password });
};

export const recoveryPasswordHandler = ({ payload }) => axios.post(urls.RECOVERY.stringify(), payload);

export const postLinkRegistrationHandler = ({ payload: { token, ...form } }) => axios.post(urls.LINK_REGISTRATION.stringify(), form, {
    headers: {
        'X-Authorization': token
    }
});

export const postSubscribeNotificationHandler = async ({ payload }) => {
    const fcmToken = await getFcmToken();
    return axios.post(urls.SUBSCRIBE_NOTIFICATION.stringify(), { ...payload, fcmToken });
};
export const postUnsubscribeNotificationHandler = async ({ payload }) => {
    const fcmToken = await getFcmToken();
    return axios.post(urls.UNSUBSCRIBE_NOTIFICATION.stringify(), { ...payload, fcmToken });
};
export const putNotificationOptionsHandler = ({ payload }) => axios.put(urls.NOTIFICATION_OPTIONS.stringify(), payload);
export const getNotificationOptionsHandler = () => axios.get(urls.NOTIFICATION_OPTIONS.stringify());

export const getLoginInfoHandler = ({ payload }) => axios.get(urls.GET_LOGIN_INFO.stringify(), {
    params: {
        'authtoken': payload.token
    }
});

export const postAvatarHandler = ({ payload }) => axios.post(urls.AVATAR.stringify(), payload);
